import axios from "axios";
import {
    ADD_NEW_USER_DEGREE,
    DELETE_USER_DEGREE,
    UPDATE_USER_DEGREE,
} from "./RestCatalog";


const addNewUserDegree = (payload) => {
    return axios.post(ADD_NEW_USER_DEGREE, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const deleteUserDegree = (payload) => {
    return axios.post(DELETE_USER_DEGREE, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const updateUserDegree = (payload) => {
    return axios.post(UPDATE_USER_DEGREE, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

export { addNewUserDegree, deleteUserDegree, updateUserDegree };

